import { initIntakeFormApp } from './intake_form';
import { initSdnNotificationApp, initAbTestingGroupAApp } from './notification';

async function init() {
  await initIntakeFormApp()
  initSdnNotificationApp()
  initAbTestingGroupAApp()
}

init();
